import { Spinner } from "./Spinner";
import { Text } from "./Text";

export const Loader = ({
  horizontal = false,
  version,
  label,
  isBackgroundBlurred = false,
  color = "black",
}: {
  horizontal?: boolean;
  version?: number;
  label?: string;
  isBackgroundBlurred?: boolean;
  color?: string;
}) => {
  if (horizontal) {
    return <span className="horizontal-loader" style={{ color }}></span>;
  }

  if (version === 2) {
    // new white loader, refer: https://www.figma.com/design/yXqLydKweUCiqyaWr5OABZ/Engagement-%7C-Final-Delivery?node-id=9556-8215&t=ibBQKAsS9Xs6JbDa-0
    return (
      <div className="absolute inset-0 z-20 flex items-center justify-center">
        <div className="flex flex-col items-center">
          <div className="h-[1.625rem] w-[1.625rem] animate-spin rounded-full border-4 border-stg-grey-4 border-t-transparent"></div>
        </div>
      </div>
    );
  }

  return (
    <div
      className="fixed z-50 flex h-full w-full flex-col items-center justify-center gap-5"
      data-testid="screen-loader"
    >
      <div
        className={`fixed z-10 h-full w-full bg-black/50 ${isBackgroundBlurred ? "backdrop-blur-sm backdrop-saturate-150" : "loader-container opacity-50"}`}
      />
      <Spinner />
      {label && (
        <div className="z-20">
          <Text appearance="primary" size={3} alignment="center" tag="p">
            {label}
          </Text>
        </div>
      )}
    </div>
  );
};
